export const AdditionalFinancingEnum = {
    ENTRANCE_GRANT: {id: 1, description: "Единовременное денежное пособие (студенты) при поступлении в ОВПО"},
    GRADUATION_GRANT: {id: 2, description: "Единовременное денежное пособие (студенты) по окончании ОВПО"},
    CLOTHING_AND_FOOTWEAR_EXPENSES: {id: 3, description: "Расходы на одежду, обуви (студенты)"},
    DORMITORY_EXPENSES: {id: 4, description: "Расходы за проживание в общежитии в год (студенты, магистранты, докторанты)"},
    FOOD_ALLOWANCE: {id: 5, description: "Социальная выплата на питание"}
}